import clsx from 'clsx'
import React, { forwardRef } from 'react'

import { type IconProp } from 'slab/types'

interface TooltipContainerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children: React.ReactNode;
  icon?: IconProp;
  open: boolean;
}

export const TooltipContainer = forwardRef<
  HTMLDivElement,
  TooltipContainerProps
>(({ children, icon: Icon, open = 'open', ...props }, forwardedRef) => {
  return (
    <div
      {...props}
      className={clsx(
        'group/tooltip',
        'max-w-[--popper-available-width]',
        'data-[state=closed]:animate-fade-out',
        'data-[state=open]:animate-fade-in',
        'data-[side=top]:pb-2 data-[side=bottom]:pt-2 data-[side=left]:pr-2 data-[side=right]:pl-2'
      )}
      data-state={open ? 'open' : 'closed'}
      ref={forwardedRef}
    >
      <div
        // The `data-side` attribute will be set automatically when the
        // `<TooltipContainer>` is composed with the `<Popper>` primitives.
        className={clsx(
          'bg-gray-800 text-white rounded-lg p-2 max-w-80',
          'body-sm text-left',
          'group-data-[state=open]/tooltip:group-data-[side=top]/tooltip:animate-slide-down-and-fade-in group-data-[state=open]/tooltip:group-data-[side=right]/tooltip:animate-slide-left-and-fade-in group-data-[state=open]/tooltip:group-data-[side=left]/tooltip:animate-slide-right-and-fade-in group-data-[state=open]/tooltip:group-data-[side=bottom]/tooltip:animate-slide-up-and-fade-in group-[]/tooltip:fill-mode-forwards',
          'relative'
        )}
      >
        <div className='flex'>
          {Icon && (
            <span className='mr-1 h-4 flex items-center'>
              <Icon size={12} />
            </span>
          )}
          <span>{children}</span>
        </div>
      </div>
    </div>
  )
})
